import "./src/styles/reset-layer.css";
import "./src/styles/index.scss";
import "@sproutsocial/seeds-react-theme/css/theme-all";
import "@sproutsocial/racine/css/components";
import "@sproutsocial/seeds-react-menu/base/css";
import "focus-visible";
import "./includeSprite.js";
import { isLoggedIn } from "./src/utils/auth.js";

export const onClientEntry = async () => {
  if (typeof IntersectionObserver === "undefined") {
    await import("intersection-observer");
  }

  if (window !== "undefined" && window.gtag) {
    window.gtag("set", "dimension1", isLoggedIn());
  }
};
